import { about } from "../lib/content";
import { ArrowRightIcon, CheckIcon } from "./Icons";

export default function AboutCloudlaya() {
  return (
    <section className="section-pad bg-ink-soft">
      <div className="container-page">
        <div className="max-w-2xl">
          <span className="eyebrow">{about.eyebrow}</span>
          <h2 className="h-section mt-4">{about.heading}</h2>
          <p className="lead">{about.body}</p>
        </div>

        <dl className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {about.stats.map((stat) => (
            <div key={stat.label} className="card p-6 shadow-card">
              <dt className="text-3xl font-extrabold tracking-tight text-brand-600">
                {stat.value}
              </dt>
              <dd className="mt-2 text-sm font-medium text-ink-muted">{stat.label}</dd>
            </div>
          ))}
        </dl>

        <div className="mt-12 card p-8 shadow-card">
          <h3 className="text-lg font-semibold text-ink">The cloud partner behind Qost.ai</h3>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink-muted">
            {about.servicesIntro}
          </p>

          <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {about.services.map((service) => (
              <li key={service} className="flex items-center gap-3 text-sm text-ink">
                <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-600">
                  <CheckIcon className="h-3 w-3" />
                </span>
                {service}
              </li>
            ))}
          </ul>

          <a
            href={about.cta.href}
            target="_blank"
            rel="noreferrer noopener"
            className="btn-ghost mt-8"
          >
            {about.cta.label}
            <ArrowRightIcon />
          </a>
        </div>
      </div>
    </section>
  );
}
